import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ProductListState from "@store/Framework/Store/Store/Pages/ProductList/ProductListState";
import { Draft } from "immer";

const initialState: ProductListState = {
    example: false,
};

const reducer = {
    "Store/Pages/ProductList/SetIsFilterNavOpen": (draft: Draft<ProductListState>, action: { isOpen?: boolean }) => {
        draft.example = action.isOpen;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
